class accordionContainer extends HTMLElement {
  constructor() {
    super();
    this.accordionButtons = this.querySelectorAll(".js-accordion-button") || this.querySelectorAll("h2");
    this.init();
  }
  init() {
    this.accordionButtons.forEach((button) => {
      button.addEventListener("click", () => {
        const accordionContent = button.nextElementSibling;
        button.classList.toggle("accordion__item--button-active");
        if (button.classList.contains("accordion__item--button-active")) {
          accordionContent.style.maxHeight = accordionContent.scrollHeight + "px";
        } else {
          accordionContent.style.maxHeight = 0;
        }
      });
    });
  }
}
customElements.define("accordion-container", accordionContainer);
if (!customElements.get("vt-slider-component")) {
  customElements.define(
    "vt-slider-component",
    class VTSlideComponent extends HTMLElement {
      constructor() {
        super();
        this.swiper = null;
        this.loop = this.getAttribute("data-loop");
        this.pagination = this.getAttribute("data-pagination");
        this.navigation = this.getAttribute("data-navigation");
        this.scrollbar = this.getAttribute("data-scrollbar");
        this.onSwiperDesktop = this.getAttribute("data-on-swiper-desktop") === "true";
        this.onSwiperMobile = this.getAttribute("data-on-swiper-mobile") === "true";
        this.slidesPerViewDesktop = Number(
          this.getAttribute("data-slides-per-view-desktop")
        );
        this.slidesPerViewMobile = Number(
          this.getAttribute("data-slides-per-view-mobile")
        );
        this.spaceBetweenDesktop = Number(
          this.getAttribute("data-space-between-desktop")
        );
        this.spaceBetweenMobile = Number(
          this.getAttribute("data-space-between-mobile")
        );
        if (!this.onSwiperDesktop) {
          this.slidesPerViewDesktop = "auto";
          this.spaceBetweenDesktop = 0;
        }
        if (!this.onSwiperMobile) {
          this.slidesPerViewMobile = "auto";
          this.spaceBetweenMobile = 0;
        }
        if (this.pagination && this.querySelector(".swiper-pagination")) {
          this.elPagination = this.querySelector(".swiper-pagination");
        }
        if (this.navigation && this.querySelector(".swiper-button-next")) {
          this.elNavigationNext = this.querySelector(".swiper-button-next");
        }
        if (this.navigation && this.querySelector(".swiper-button-prev")) {
          this.elNavigationPrev = this.querySelector(".swiper-button-prev");
        }
        if (this.scrollbar && this.querySelector(".swiper-scrollbar")) {
          this.elScrollbar = this.querySelector(".swiper-scrollbar");
        }
      }
      connectedCallback() {
        this.swiper = new Swiper(this, {
          enabled: this.onSwiperMobile,
          slidesPerView: this.slidesPerViewMobile,
          spaceBetween: this.spaceBetweenMobile,
          loop: this.loop,
          pagination: {
            el: this.elPagination || null,
            clickable: true
          },
          navigation: {
            nextEl: this.elNavigationNext || null,
            prevEl: this.elNavigationPrev || null
          },
          scrollbar: {
            el: this.elScrollbar || null
          },
          breakpoints: {
            990: {
              enabled: this.onSwiperDesktop,
              slidesPerView: this.slidesPerViewDesktop,
              spaceBetween: this.spaceBetweenDesktop
            }
          }
        });
      }
    }
  );
}
